import { StationSource } from './../../../core/models/station-source';
import { IStationCardField } from './../station-card.model';
import { ProfileModelService } from './../../../profile/profile-model.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-station-card-dialog',
  templateUrl: './station-card-dialog.component.html',
  styleUrls: ['./station-card-dialog.component.scss', './station-card-dialog-dark.component.scss']
})
export class StationCardDialogComponent implements OnInit {

  stationSourceList: StationSource[] = [];
  sourceSelected: StationSource;

  constructor(
    public dialogRef: MatDialogRef<StationCardDialogComponent>
    , private profileModelService: ProfileModelService
    , @Inject(MAT_DIALOG_DATA) public data: IStationCardField
  ) { }

  ngOnInit(): void {
    this.stationSourceList = this.data.stationSources;
    this.setDefaultStationSource();
  }

  setDefaultStationSource() {
    const defaultStationSource: StationSource = this.profileModelService.getDefaultStationSource();
    if (defaultStationSource) {
      this.sourceSelected = this.stationSourceList.find(
        (element) => element.id === defaultStationSource.id);
    } else {
      this.sourceSelected = null;
    }
  }

  public cancel(){
    this.dialogRef.close(false);
  }

  public confirm(){
    if (this.sourceSelected) {
      const idStation = this.data.mapStationSources.get(this.sourceSelected.id);
      this.dialogRef.close(idStation);
    } else {
      this.cancel();
    }
  }

}
